/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/* eslint-disable @typescript-eslint/no-useless-constructor */
import { type OnChanges, type SimpleChanges, Component, EventEmitter, Injector, Output } from '@angular/core';
import {
    I18nService,
    TimeService, UtilService,
} from '@dm/core';
import { SYSTEM_VSTORE_ID, SYSTEM_VSTORE_NAME } from 'app/common/constants';
import { type CIFSClient, type FileSystem } from 'app/common/types/mo';

import { FileSystemEntryE } from '../../../file-system/create-file-system/create-file-system.component';
import { CreateStyleE } from '../../share.enum';
import { CifsShareService } from '../cifs-share.service';
import { CifsShareStrService } from '../cifs-share-str.service';
import { ClientCifsShareService } from '../client-cifs-share/client-cifs-share.service';
import { CopyFromCifsShareComponent } from '../copy-from-cifs-share/copy-from-cifs-share.component';

@Component({
    selector: 'app-copy-from-cifs-share-s',
    templateUrl: './copy-from-cifs-share-s.component.html',
    styleUrls: ['./copy-from-cifs-share-s.component.scss'],
})

export class CopyFromCifsShareSComponent extends CopyFromCifsShareComponent implements OnChanges {
    @Output() cifsShareSwitchUpdate = new EventEmitter();
    @Output() cifsSharePermissionUpdate = new EventEmitter();

    i18nLabel = {
        cifsShareTitle: this.i18nService.get('common.cifsShare_lab'),
        permissionTitle: this.i18nService.get('service.share_simplifiedMode_create_accessPermission_lab'),
        allUserLab: this.i18nService.get('service.share_simplifiedMode_create_accessPermission_allUsers_value'),
        manuUserLab: this.i18nService.get('service.share_simplifiedMode_create_accessPermission_manualUsers_value'),
        allUserLabTip: this.i18nService.get('service.share_simplifiedMode_create_accessPermission_allUsers_tip'),
        allUserLabReadOnlyTip: this.i18nService.get('service.share_simplifiedMode_create_accessPermission_allUsers_interFS_tip'),
        manuUserLabTip: this.i18nService.get('service.share_simplifiedMode_create_accessPermission_manualUsers_tip'),
    };

    supportSmartGui = false;
    isCopyFrom = false;
    vstoreId = SYSTEM_VSTORE_ID;
    vstoreName = SYSTEM_VSTORE_NAME;

    // 客户端列表
    userList: CIFSClient[] = [];
    entry = FileSystemEntryE.Main;
    selectedFilesystem: FileSystem;
    FileSystemEntryE = FileSystemEntryE;

    constructor(
        injector: Injector,
        str: CifsShareStrService,
        service: CifsShareService,
        clientCifsShareService: ClientCifsShareService,
        timeService: TimeService,
        utilService: UtilService,
        public i18nService: I18nService,
    ) {
        super(
            injector,
            str,
            service,
            clientCifsShareService,
            timeService,
            utilService,
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        // fsName可能为空，为空也要更新
        if (changes.fsName) {
            super.changeSharePathAndName(this.fsName, false);
        }

        if (changes.entry) {
            this.updateDefaultAccessVal();
        }
    }

    initVm(): void {
        super.initVm();

        this.vm.patchValue({
            CIFScreateStyle: CreateStyleE.All,
        });

        // 用户列表默认值
        this.userList = this.createShare[this.vm.value.CIFScreateStyle].permissions;
    }

    onSwitchChange($event): void {
        super.onSwitchChange($event);

        this.cifsShareSwitchUpdate.emit();
    }

    updateCifsShareName(cifsShareName: string): void {
        if (!cifsShareName) {
            return;
        }

        this.sendShareNameChangedData.emit(cifsShareName);
        this.createShare.all.share.NAME = cifsShareName;
        this.createShare.new.share.NAME = cifsShareName;
        this.createShare.copyFrom.share.NAME = cifsShareName;
    }

    onPermissionCreateStyleChange(value: CreateStyleE): void {
        this.permissionIsDefault = value === CreateStyleE.All;

        this.cifsSharePermissionUpdate.emit();
    }

    onTableClientCifsChange(tableData: CIFSClient[]): void {
        const style = this.vm.value.CIFScreateStyle;
        this.createShare[style].permissions = tableData;
    }
}
